/* DistrictPrime Radio x Horizon sticky add-to-cart bar (phones).
   When the bar is shown (data-stuck="true") and the viewport is < 750px, lift #dp-radio above it:
   --dpr-bottom = bar height + 8px. When the bar hides, or on desktop, the radio goes back to its default 8px.
   Desktop (>= 750px): the radio is an inline bar above the footer, so it scrolls under the floating sticky bar.
   While the radio is inside the bar's strip at the bottom of the screen, the bar steps aside (data-dpr-yield on
   <sticky-add-to-cart>), the same way Horizon already hides it at the footer. */
(function(){
  var mq = window.matchMedia("(max-width: 749px)"), bar = null, ro = null;
  function radio(){ return document.getElementById("dp-radio"); }
  function update(){
    var r = radio(); if (!r) return;
    var on = !!(bar && mq.matches && bar.getAttribute("data-stuck") === "true" && bar.offsetHeight > 0);
    if (on){ r.style.setProperty("--dpr-bottom", (bar.offsetHeight + 8) + "px"); r.setAttribute("data-dpr-lift", ""); }
    else { r.style.removeProperty("--dpr-bottom"); r.removeAttribute("data-dpr-lift"); }
    yieldDesk(); if (typeof onScroll === "function") onScroll();
  }
  function yieldDesk(){
    var r = radio(), host = bar && bar.closest("sticky-add-to-cart"); if (!r || !host) return;
    var y = false;
    if (!mq.matches && bar.getAttribute("data-stuck") === "true"){
      var a = r.getBoundingClientRect(), cs = getComputedStyle(bar), b = bar.getBoundingClientRect(),
          top = innerHeight - (parseFloat(cs.bottom) || 0) - bar.offsetHeight - 8;   // bar's resting strip, ignoring its slide transform
      y = a.bottom > top && a.top < innerHeight && a.right > b.left && a.left < b.right;
    }
    if (y) host.setAttribute("data-dpr-yield", ""); else host.removeAttribute("data-dpr-yield");
  }
  /* Product pages on phones: compact pill (title + play/pause, see dp-radio-product.css), and it also steps aside
     whenever it would sit on the size/variant picker, quantity or any buy button. */
  var BUY = "variant-picker, product-form-component, quantity-selector-component, add-to-cart-component, .shopify-payment-button, shopify-accelerated-checkout, form[action*='/cart/add'] button, form[action*='/cart/add'] label";
  function buyZone(){
    if (!isPdp()) return [];   // collection grids have (invisible) quick-add forms on every card; only the product page's own buy area counts
    return [].slice.call(document.querySelectorAll(BUY)).filter(function(e){ return !e.closest("sticky-add-to-cart") && !e.closest("#dp-radio") && !e.closest("product-card, .product-card, quick-add-component, .quick-add, dialog, product-recommendations"); });
  }
  /* Compact pill only on product pages on phones (that's where the full player would sit on the size picker / buy buttons).
     The pill keeps play/pause AND next. Tapping the song title opens the full player; the collapse button (or the title again) closes it. */
  var expanded = false;
  function isPdp(){ return /\/products\//.test(location.pathname) && !!document.querySelector("variant-picker, product-form-component"); }
  function wire(r){
    if (r.__dprWired) return; var ti = r.querySelector(".dpr__title"), bt = r.querySelector(".dpr__btns"); if (!ti || !bt) return;
    r.__dprWired = true;
    var x = document.createElement("button"); x.type = "button"; x.className = "dpr__btn dpr-collapse"; x.setAttribute("aria-label", "Collapse player");
    x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.4"/></svg>';
    bt.appendChild(x);
    function toggle(){ if (!isPdp() || !mq.matches) return; expanded = !expanded; compact(); onScroll(); }
    ti.addEventListener("click", toggle); x.addEventListener("click", function(){ expanded = false; compact(); onScroll(); });
    ti.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " "){ e.preventDefault(); toggle(); } });
  }
  function compact(){
    var r = radio(); if (!r) return;
    var pdp = mq.matches && isPdp();
    if (pdp){ wire(r); var ti = r.querySelector(".dpr__title");
      if (ti){ ti.setAttribute("role", "button"); ti.tabIndex = 0; ti.setAttribute("aria-expanded", expanded ? "true" : "false"); ti.setAttribute("aria-label", (expanded ? "Collapse player: " : "Show full player: ") + ti.textContent); } }
    if (pdp && !expanded) r.setAttribute("data-dpr-compact", ""); else r.removeAttribute("data-dpr-compact");
    if (pdp && expanded) r.setAttribute("data-dpr-expanded", ""); else r.removeAttribute("data-dpr-expanded");
  }
  /* Phones: the fixed mini player must never sit on top of the District Dash buttons (ENTER THE DISTRICT / SHOP THE NEW DROP).
     While it would overlap one, it fades out (data-dpr-yield on #dp-radio) and comes back once the button scrolls away. */
  function yieldCta(){
    var r = radio(); if (!r) return;
    var y = false;
    if (mq.matches){
      var a = r.getBoundingClientRect(), cs = [].slice.call(document.querySelectorAll(".dd__entry .dd__b, .dd__entry .dd__b2, .dd__entry a, .dd__over .dd__b2, .dd__over a")).concat(buyZone());
      for (var k = 0; k < cs.length && !y; k++){ var b = cs[k].getBoundingClientRect();
        if (b.width && b.height && a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom) y = true; }
    }
    if (y) r.setAttribute("data-dpr-yield", ""); else r.removeAttribute("data-dpr-yield");
  }
  var tick = false;
  function onScroll(){ if (tick) return; tick = true; requestAnimationFrame(function(){ tick = false; compact(); yieldDesk(); yieldCta(); }); }
  function hook(){
    var host = document.querySelector("sticky-add-to-cart");
    var b = host && (host.querySelector(".sticky-add-to-cart__bar[data-stuck]") || host.querySelector("[data-stuck]"));
    if (!b || b === bar) return update();
    bar = b;
    new MutationObserver(update).observe(bar, {attributes: true, attributeFilter: ["data-stuck"]});
    if (window.ResizeObserver){ ro = new ResizeObserver(update); ro.observe(bar); }
    update();
  }
  function init(){
    compact(); hook();
    var r0 = radio(); if (r0) r0.addEventListener("transitionend", function(){ onScroll(); });
    /* the bar markup is re-rendered on variant change; re-hook if it is replaced */
    var host = document.querySelector("sticky-add-to-cart");
    if (host) new MutationObserver(hook).observe(host, {childList: true, subtree: true});
    addEventListener("scroll", onScroll, {passive: true}); addEventListener("resize", onScroll);
    setTimeout(onScroll, 300); setTimeout(onScroll, 1500);   // after fonts/hero settle
    if (mq.addEventListener) mq.addEventListener("change", update); else if (mq.addListener) mq.addListener(update);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
